import { render, staticRenderFns } from "./EditFormValidator.vue?vue&type=template&id=6564596c"
import script from "./EditFormValidator.vue?vue&type=script&lang=js"
export * from "./EditFormValidator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports